import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "theme-settings-btn p-0 border-0 bg-transparent",
  type: "button",
  "data-bs-toggle": "offcanvas",
  "data-bs-target": "#settingsSidebar",
  "aria-controls": "settingsSidebar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("i", { class: "material-symbols-outlined" }, " settings ", -1)
  ]))]))
}